import { AccessFlexSchema, AccessFlexSchema2 } from './accessflex'
import EvQuestionSchema from './ask-your-ev-question'
import BrochureSchema from './brochure'
import ContactUsSchema from './contact-us'
import ContactUsDealerSchema from './contact-us-dealer'
import DiscretionaryCommissionSchema from './discretionary-commission'
import FleetCallbackSchema from './fleet-callback'
import GetAQuoteSchema from './get-a-quote'
import GrYarisLotterySchema from './gr-yaris-lottery'
import InternalCansSchema from './internal-cans'
import KintoChangeNumberPlateSchema from './kinto/change-number-plate'
import KintoContactUsSchema from './kinto/contact-us'
import KintoFleetExchangeSchema from './kinto/fleet-exchange'
import KintoBchRequestACallbackSchema from './kinto/get-a-quote'
import KintoRemoveNumberPlateOnlineSchema from './kinto/remove-number-plate/online'
import KintoRemoveNumberPlatePostalSchema from './kinto/remove-number-plate/postal'
import KintoExistingServiceBookingSchema from './kinto/service-booking/existing'
import KintoNewServiceBookingSchema from './kinto/service-booking/new'
import KintoUsedCarsSchema from './kinto/used-cars'
import KintoRequestACallbackSchema from './kinto-request-a-callback'
import KmiSchema from './kmi'
import MarketingPreferencesSchema from './marketing-preferences'
import NewsletterSchema from './newsletter'
import FleetNewsletterSchema from './newsletter-fleet'
import PartsAccessoriesSchema from './parts-accessories'
import PowerOfChoiceSchema from './power-of-choice'
import PreApprovalSchema from './pre-approval'
import PrizeDrawSchema from './prize-draw'
import PrizeDrawCmsSchema from './prize-draw/cms'
import DunlopPrizeDrawSchema from './prize-draw/dunlop-limited-edition-racket'
import GolfPrizeDrawSchema from './prize-draw/golf-masterclass'
import GolfLocationsPrizeDrawSchema from './prize-draw/golf-masterclass-locations'
import SolusSchema from './prize-draw/solus'
import RccPreferencesSchema from './rcc-preferences'
import RequestACallbackSchema from './request-a-callback'
import ReserveSchema from './reserve'
import ReserveLbxSchema from './reserve-lbx'
import StockCarEnquirySchema from './stock-car-enquiry-schema'
import TestDriveSchema from './test-drive'
import ToyotaChrSchema from './toyota-chr'
import ToyotaThonSchema from './toyota-thon'
import UberOfferSchema from './uber'
import UnsubscribeSchema from './unsubscribe'
import UsedCarSchema from './used-car-enquiry'
import VideoConsultationSchema from './video-consultation'

export {
  AccessFlexSchema,
  AccessFlexSchema2,
  BrochureSchema,
  ContactUsDealerSchema,
  ContactUsSchema,
  DiscretionaryCommissionSchema,
  DunlopPrizeDrawSchema,
  EvQuestionSchema,
  FleetCallbackSchema,
  FleetNewsletterSchema,
  GetAQuoteSchema,
  GolfLocationsPrizeDrawSchema,
  GolfPrizeDrawSchema,
  GrYarisLotterySchema,
  InternalCansSchema,
  KintoBchRequestACallbackSchema,
  KintoChangeNumberPlateSchema,
  KintoContactUsSchema,
  KintoExistingServiceBookingSchema,
  KintoFleetExchangeSchema,
  KintoNewServiceBookingSchema,
  KintoRemoveNumberPlateOnlineSchema,
  KintoRemoveNumberPlatePostalSchema,
  KintoRequestACallbackSchema,
  KintoUsedCarsSchema,
  KmiSchema,
  MarketingPreferencesSchema,
  NewsletterSchema,
  PartsAccessoriesSchema,
  PowerOfChoiceSchema,
  PreApprovalSchema,
  PrizeDrawCmsSchema,
  PrizeDrawSchema,
  RccPreferencesSchema,
  RequestACallbackSchema,
  ReserveLbxSchema,
  ReserveSchema,
  SolusSchema,
  StockCarEnquirySchema,
  TestDriveSchema,
  ToyotaChrSchema,
  ToyotaThonSchema,
  UberOfferSchema,
  UnsubscribeSchema,
  UsedCarSchema,
  VideoConsultationSchema,
}
